var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardInfo"},[_c('span',{staticClass:"cardInfo--row"},[_vm._v("カード番号")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("cardNumberFormat")(_vm.cardNumber)))]),_vm._v(" "),_c('span',{staticClass:"cardInfo--row"},[_vm._v("カード有効期限")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("cardExpirationFormat")(_vm.cardExpiration)))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b7f436a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/partials/CardInfo.vue
// module id = null
// module chunks = 